export function initPanel(id, options = {}) {
  const panel = document.getElementById(id);
  if (panel) {
    window.Phoenix.panels[id] = new window.Toolkit.Panel(panel, options);
  }
}

export function destroyPanel(id) {
  if (Object.hasOwn(window.Phoenix.panels, id)) {
    window.Phoenix.panels[id].destroy();
  }
}

export function showPanel(id) {
  if (Object.hasOwn(window.Phoenix.panels, id)) {
    window.Phoenix.panels[id].show();
  }
}

export function closePanel(id) {
  if (Object.hasOwn(window.Phoenix.panels, id)) {
    window.Phoenix.panels[id].hide();
  }
}
